export const ADDRESS_REQUIRED_UPDATE_FIELDS = {
  PERIOD: 'period',
};
